import React from 'react';
import './video-css.css';
import {Tweet} from 'react-twitter-widgets';

const Video = () => (
    <div>
        <div className="video-div-1a">
            <h1 className="video-h1">
                Video Views on Demand
            </h1>
        </div>
        {/*<div className="video-div-1a">*/}
            {/*<p className="video-p-1a">*/}
                {/*We focus millions of video views onto your video Tweet(s).*/}
            {/*</p>*/}
        {/*</div>*/}
        <div id="video-div-1c">
            <div className='video-div-2b'>
                <h3>
                    Rapid Deployment
                </h3>
                <p className="video-p-1a">
                    Capacity: 100,000 to 4,000,000 views / hour.
                </p>
            </div>
            <div className="video-div-2b">
                <h3>
                    Effective & Efficient
                </h3>
                <p className="video-p-1a">
                    Rates range from $0.002 to $0.004 / video view.
                </p>
            </div>
        </div>
        <div id="video-div-1b">
            <div className="video-div-2a">
                <Tweet options={{width: 'auto'}} tweetId='831642428247506945'/>
            </div>
            <div className="video-div-2a">
                <Tweet options={{width: 'auto'}} tweetId='816397048840855552'/>
            </div>
            <div className="video-div-2a">
                <Tweet options={{width: 'auto'}} tweetId='798162277249720320'/>
            </div>
            <div className="video-div-2a">
                <Tweet options={{width: 'auto'}} tweetId='814479109480968193'/>
            </div>
        </div>

    </div>
);

export default Video;


// WEBPACK FOOTER //
// ./src/components/core/video/Video.js